import React from 'react';
export function HeaderBar() {
  return <div className="w-full bg-navy-900 text-white py-4 px-4 border-b-4 border-gold-600" data-id="element-32">
      <div className="max-w-5xl mx-auto text-center space-y-1" data-id="element-33">
        <a href="tel:+13213523771" className="block" data-id="element-34">
          <h2 className="text-sm md:text-base font-bold tracking-widest uppercase text-gray-200 hover:text-white transition-colors cursor-pointer" data-id="element-35">
            CENTRO INDEPENDIENTE DE INVESTIGACIÓN ESPIRITUAL — AMÉRICAS
          </h2>
        </a>
        <a href="tel:+13053811985" className="text-xs md:text-sm text-gray-300 font-medium hover:text-white transition-colors" data-id="element-36">
          Unidad de Investigación: Prácticas Esotéricas y Bienestar Emocional
        </a>
        <p className="text-xs text-gray-400 font-mono mt-1" data-id="element-37">
          Miami, Florida | Reporte Especial Nº 0039 | Publicación Autorizada
        </p>
      </div>
    </div>;
}